import { eventCorpSliceActions } from "./event-corp";
import { notificationsActions } from "./notifications";
import responseNotification from "components/utils/responseNotification";

import { auth0SliceActions } from "./auth0";
import store from "store";

export const fetchEventCorp = () => {
    return async (dispatch, getState) => {
        dispatch(
            notificationsActions.showNotificationEventCorp({
                status: "pending",
                title: "Aguarde!",
                message: "Consultando API",
            })
        );

        const fetchData = async (accessToken) => {
            const apiUri = process.env.REACT_APP_DASHBOARD_API;
            const response = await fetch(
                apiUri + "b3/eventcorp",
                {
                    method: "GET",
                    headers: { Authorization: "Bearer " + accessToken },
                }
            );

            responseNotification(
                response.status,
                notificationsActions.showNotificationEventCorp,
                auth0SliceActions.updateIsAuthenticated,
                dispatch
            );

            if (!response.ok) {
                throw new Error(response.statusText);
            }
            const data = await response.json();

            return data;
        };

        try {
            const accessToken = store.getState().auth0.accessToken;
            const newEventCorp = await fetchData(accessToken);
            dispatch(eventCorpSliceActions.updateEventCorp(newEventCorp));
            dispatch(
                notificationsActions.showNotificationEventCorp({
                    status: "success",
                    title: "Sucesso!",
                    message: "A API retornou algo suculento",
                })
            );
        
        } catch (error) {
            console.log(error);
        }
    };
};
